<mat-expansion-panel class="base-component panel-header">
  <mat-expansion-panel-header class="mat-indicator">
    <a class="title font-color title-size">Empresa</a>
  </mat-expansion-panel-header>
  <div class="content font-color" *ngIf="business; else elseBlock">
    <p class="font-size">{{ business.name }}</p><br>
    <p><b>Tel:</b> {{ nineExtra(business.phone) | mask: phoneMask}}</p>
    <p><b>Cel:</b> {{ nineExtra(business.cellphone) | mask: phoneMask }}</p>
    <p><b>Email:</b> {{ business.email }}</p>
  </div>
  <ng-template #elseBlock>
    <button mat-raised-button align="end" color="primary" (click)="chooseBusiness()">
      <mat-icon>add</mat-icon>
      Atribuir Empresa
    </button>
  </ng-template>
</mat-expansion-panel>
